import ERROR_MAP from './errorMap.json'
import { LANG } from '../language/lang'

const LEGACY_ERROR_ALIASES = {
    LOGIN: {
        USER_NOT_FOUNDED: 'USER_NOT_FOUND',
        INCORECT_LOGIN_OR_PASSWORD: 'INVALID_CREDENTIALS',
        USER_NOT_FOUND: 'USER_NOT_FOUND',
        INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
        INVALID_PASSWORD: 'INVALID_PASSWORD',
    },
    REGISTRATION: {
        INCORECT_LOGIN_OR_PASSWORD: 'INVALID_CREDENTIALS',
        USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
        EMAIL_ALREADY_EXISTS: 'EMAIL_ALREADY_EXISTS',
        FINGERPRINT_ALREADY_EXISTS: 'FINGERPRINT_ALREADY_EXISTS',
        INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    },
    AUTH: {
        USER_NOT_FOUNDED: 'USER_NOT_FOUND',
        INCORECT_LOGIN_OR_PASSWORD: 'INVALID_CREDENTIALS',
        USER_NOT_FOUND: 'USER_NOT_FOUND',
        INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
        INVALID_PASSWORD: 'INVALID_PASSWORD',
    },
}

export function MapError(module, code) {
    const safeCode = typeof code === 'string'
        ? code
        : code?.code ?? code?.message ?? 'UNEXPECTED_ERROR'

    const normalizedModule = module || 'UNEXPECTED_ERROR'
    const normalizedCode = LEGACY_ERROR_ALIASES[normalizedModule]?.[safeCode] || safeCode
    const mappedError =
        ERROR_MAP[normalizedModule]?.[normalizedCode] ||
        ERROR_MAP[normalizedModule]?.[safeCode] ||
        ERROR_MAP['UNEXPECTED_ERROR'] || {}

    return {
        field: mappedError.field || ['global'],
        message: LANG(mappedError.text || 'ERROR_TEXT_UNEXPECTED_ERROR'),
        severity: mappedError.severity || 'error',
        showInUI: mappedError.showInUI !== false
    }
}